__turbopack_context__.v({
  "profileChecklistItem": "quRmHq_profileChecklistItem",
  "profileChecklistItemButton": "quRmHq_profileChecklistItemButton",
  "profileChecklistItemComplete": "quRmHq_profileChecklistItemComplete",
  "profileChecklistItemDeleteButton": "quRmHq_profileChecklistItemDeleteButton",
});
